import { createContext } from 'react'

const ShopContext = createContext()

export default ShopContext
